import React from 'react';
import { Section } from '../ui/Section';
import { AlertCircle, BatteryWarning } from 'lucide-react';
import { motion } from 'framer-motion';
export function Problem() {
  const problems = ['Exigirte rendir en el trabajo incluso agotada', 'Estudiar con la cabeza saturada', 'Sostener la casa sin pausas reales', 'Pensar en todo, todo el tiempo', 'Sentir culpa incluso cuando descansás'];
  return <Section background="white" className="text-center" data-id="element-229">
      <div className="max-w-4xl mx-auto" data-id="element-230">
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6" data-id="element-231">
          El problema no es que te falte energía
        </h2>

        <p className="text-2xl text-slate-700 mb-10 font-medium" data-id="element-232">
          El problema es que la perdés todos los días sin darte cuenta.
        </p>

        <div className="bg-slate-50 p-8 rounded-3xl border border-slate-200 mb-12" data-id="element-233">
          <p className="text-lg font-bold text-slate-500 uppercase tracking-wider mb-6" data-id="element-234">
            Se va en:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-235">
            {problems.map((item, i) => <div key={i} className="flex items-center gap-3 p-3 bg-white rounded-lg border border-slate-100 shadow-sm" data-id="element-236">
                <AlertCircle className="w-5 h-5 text-rose-500 flex-shrink-0" data-id="element-237" />
                <span className="text-slate-800 font-medium" data-id="element-238">{item}</span>
              </div>)}
          </div>
        </div>

        <motion.div className="bg-rose-50 p-8 rounded-2xl border-2 border-rose-100 inline-block max-w-2xl" whileInView={{
        scale: [1, 1.02, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-239">
          <BatteryWarning className="w-12 h-12 text-rose-500 mx-auto mb-4" data-id="element-240" />
          <p className="text-xl md:text-2xl font-bold text-rose-900 leading-tight" data-id="element-241">
            "Es como cargar una batería pinchada: por más que pares, nunca
            termina de cargarse."
          </p>
        </motion.div>
      </div>
    </Section>;
}